import type { Card, CardMeta } from "@/model/card";
import type { RelativeCoordinate } from "@/model/coordinates";
import type { Objective } from "@/model/objective";
import { isZombieType } from "@/store/stickyType";
import { stickerToString } from "@/utils/sticker";

import type { ServerObjective, ServerSticky } from "../serverModel";

export type AlterCard = Partial<Card & RelativeCoordinate & Pick<CardMeta, "zIndex">>;

export function toServerSticky(data?: AlterCard, priorities?: boolean): Partial<ServerSticky> {
  const value: Partial<ServerSticky> = {};
  if (data) {
    if (data.x !== undefined && data.y !== undefined) {
      value.a_center = [data.x, 1 - data.y];
    }
    if (data.zIndex !== undefined) {
      value.stack_pos = data.zIndex;
    }
    if (data.text !== undefined) {
      value.text = data.text;
    }
    if (data.status !== undefined) {
      value.status = data.status.name;
      value.status_class = data.status.statusClass;
    }
    if (data.transition !== undefined) {
      value.transition = data.transition;
    }
    if (data.type !== undefined && !isZombieType(data.type)) {
      value.type_id = data.type.id;
    }
    if (data.priority !== undefined) {
      if (priorities) {
        value.step_value = data.priority;
      } else {
        value.WSJF_value = data.priority;
      }
    }
    if (data.points !== undefined) {
      value.story_points = data.points;
    }
    if (data.teamId !== undefined) {
      value.team_id = data.teamId === null ? null : +data.teamId;
    }
    if (data.precondTeam !== undefined) {
      value.precond_team = data.precondTeam.name;
      value.precond_team_id = +data.precondTeam.id;
    }
    if (data.dependTeam !== undefined) {
      value.depend_team = data.dependTeam.name;
      value.depend_team_id = +data.dependTeam.id;
    }
    if (data.iterationId !== undefined) {
      value.iteration_number = data.iterationId;
    }
    if (data.flagType !== undefined) {
      value.flag_type = stickerToString(data.flagType);
    }
    if (data.risk !== undefined) {
      value.risk = data.risk;
    }
    if (data.almSourceId !== undefined) {
      value.alm_source = data.almSourceId;
    }
    if (data.almId !== undefined) {
      value.alm_issue_id = data.almId;
    }
    if (data.artId !== undefined) {
      value.art_id = data.artId === null ? null : Number(data.artId);
    }
    if (data.assignee !== undefined) {
      value.assignee = { pip_id: data.assignee?.id || null, alm_id: null };
    }
  }
  return value;
}

export function toServerObjective(
  data: Partial<Objective>,
  isStretch?: boolean,
): Partial<ServerObjective> {
  const value: Partial<ServerObjective> = {};
  if (data.id !== undefined) {
    value.objective_id = data.id;
  }
  if (data.text !== undefined) {
    value.text = data.text;
  }
  if (data.bv !== undefined) {
    value.bv = data.bv;
  }
  if (data.av !== undefined) {
    value.av = data.av;
  }
  if (data.description !== undefined) {
    value.description = data.description;
  }
  if (data.rag !== undefined) {
    value.rag = data.rag;
  }
  if (isStretch !== undefined) {
    value.is_stretch = isStretch;
  }
  return value;
}
